import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useUser } from '../../providers/UserContext';

const apiUrl = process.env.REACT_APP_API_URL;

const saveUserToDatabase = async (userData) => {
  try {
    await axios.post(`${apiUrl}/collections/save-user`, userData);
    return true;
  } catch (error) {
    console.error('Error al guardar el usuario en la base de datos:', error);
    return false;
  }
};

const LinkedInCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useUser();

  useEffect(() => {
    const handleLinkedInAuth = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');

      if (code) {
        try {
          const response = await fetch(`${apiUrl}/collections/linkedin-auth`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ 
              code, 
              redirectUri: 'http://localhost:3000/linkedin-callback' 
            })
          });

          const data = await response.json();
          const profileData = data.profile;

          const user = {
            uid: profileData.sub,
            email: profileData.email,
            displayName: profileData.name,
            photoUrl: profileData.picture || "",
            hasWelcomeMail: false,
            username: profileData.name,
            id_negocio: ""
          };

          // Primero guardamos en la base de datos
          const savedToDb = await saveUserToDatabase(user);

          localStorage.setItem('userUID', profileData.sub);
          
          if (savedToDb) {
            // Luego actualizamos el contexto
            await setUser(user);
            navigate('/dashboard');
          } else {
            console.error('Error saving user to database');
            navigate('/login');
          }
        } catch (error) {
          console.error('Error:', error);
          navigate('/login');
        }
      }
    };

    handleLinkedInAuth();
  }, [navigate, setUser]);

  return (
    <div className="p-4 text-center">
      <p>Procesando inicio de sesión de LinkedIn...</p>
      <p className="text-sm text-gray-500">Por favor, espere...</p>
    </div>
  );
};

export default LinkedInCallback;